import React from 'react';
import { connect } from 'react-redux';
import CanvasJSChart from './CanvasJSChart';
import moment from 'moment';
import 'moment-duration-format';

class DoughnutChart extends React.Component {
    render() {
        const { propId, dataPoints, fontSize, questionMetric } = this.props;

        //const dataPointsToUse = dataPoints
        //    ? dataPoints
        //    :  [
        //        { name: "Improved", y: 90, color: '#92D050' },
        //        { name: "Not Improved", y: 10, color: '#FF0000' },
        //    ];
        
        const options = {
            animationEnabled: true,
            subtitles: [{
                text: questionMetric,
                verticalAlign: "center",
                fontSize: fontSize,
                dockInsidePlotArea: true,
                fontWeight: "normal",
                fontFamily: "sans-serif"
            }],
            data: [{
                type: "doughnut",
                startAngle: 270,
                showInLegend: false,
                innerRadius: "81%",
                // indexLabel: "{name}: {y}",
                // yValueFormatString: "#,###'%'",
                dataPoints: dataPoints
            }]
        }

        return (
            <CanvasJSChart
                chartContainerId={propId}
                options={options}
                containerProps={{ height: '100%', width: '100%' }}
            />
        );
    }


}

const select = state => ({ ...state.session });

export default connect(select)(DoughnutChart);